import React from 'react';
import find from 'lodash/find';

import { Wrapper, Scores, Icon, InfoWrapper, InfoHeader } from './styled/HeaderRankStyled';
import * as Icons from './Icons/HeaderRankIcons';
import { getDisplayGamificationWeekly } from '../../../store/uiConfig';
import type { TrainerSpottingScore } from '../../../store/types';

const MINIMUM_REQUIRED_POINTS = 10;
const TOP_RANK_POSITION = 3;

const config: RankConfigItem[] = [
    { start: 0, end: 16, icon: Icons.Level1 },
    { start: 16, end: 32, icon: Icons.Level2 },
    { start: 32, end: 48, icon: Icons.Level3 },
    { start: 48, end: 64, icon: Icons.Level4 },
    { start: 64, end: 80, icon: Icons.Level5 },
    { start: 80, end: 101, icon: Icons.Level6 }
];
interface RankConfigItem {
    start: number;
    end: number;
    icon: () => JSX.Element;
}

function getItem(percentage: number, rank: number, scores: number) {
    if (scores < MINIMUM_REQUIRED_POINTS) {
        return <Icons.Level1 />;
    }

    if (rank <= TOP_RANK_POSITION) {
        return <Icons.Top />;
    }
    const configItem = find(config, (item: RankConfigItem) => item.start <= percentage && item.end > percentage);
    return (configItem || config[0]).icon();
}

interface RankProps {
    score: number;
    rank: number;
    percentage: number;
    whitelistPhrasesSpottingScore?: TrainerSpottingScore;
    localization: { getText: (key: string) => string };
}

function Rank({ score, rank, percentage, whitelistPhrasesSpottingScore = {}, localization }: RankProps) {
    if (!getDisplayGamificationWeekly()) return null;

    const { spottedPhrasesScore = 0, bonusScore = 0 } = whitelistPhrasesSpottingScore;
    return (
        <Wrapper data-testid="header_rank">
            <Scores data-testid="header_rank_scores">
                {score + bonusScore + spottedPhrasesScore}
                <InfoWrapper>
                    <InfoHeader>{localization.getText('header.rank.title')}</InfoHeader>
                    <div>{localization.getText('header.rank.message')}</div>
                </InfoWrapper>
            </Scores>
            <Icon data-testid="header_rank_icon">{getItem(percentage, rank, score)}</Icon>
        </Wrapper>
    );
}

Rank.defaultProps = {
    whitelistPhrasesSpottingScore: {
        bonusScore: 0,
        spottedPhrasesScore: 0,
        percentage: 0
    }
};

export default Rank;
